// Modo manual do NewsGrid. Só o que a busca do servidor devolve é exibido:
// a cópia de metadados gravada no bloco (target) nunca é usada para desenhar,
// porque mostraria título e resumo de notícia de outro público.

// O UID do alvo é a chave que casa a escolha do editor com a resposta da
// busca; o caminho fica de reserva, para item sem UID. O object browser grava
// o @id com o endereço público do dia em que a escolha foi feita; depois de
// uma troca de endereço (da homologação para a produção, por exemplo) o
// flatten do Volto não reconhece mais o prefixo. Resolver pelo caminho, como
// faz o servidor, evita que a notícia suma da grade só por isso.
const caminhoDe = (url, flatten) => {
  const path = flatten(url).replace(/^https?:\/\/[^/]+/i, '');
  // Caminho de conteúdo sempre começa por "/". O object_list do Volto dá a
  // cada item novo um @id próprio (um UUID): sem isto ele passaria por item
  // do formato antigo e iria para a busca como se fosse uma notícia.
  return path.startsWith('/') ? path : '';
};

export function extrairConfigs(items, flatten) {
  return (items || [])
    .map((it) => {
      if (it && it.target) {
        const t = Array.isArray(it.target) ? it.target[0] : it.target;
        // UID do alvo escolhido (não o @id da linha do object_list, que é só
        // o id da linha). Com ele a busca não depende do endereço gravado, e
        // o alvo vale mesmo sem @id.
        const uid =
          t && typeof t === 'object' && typeof t.UID === 'string' && t.UID
            ? t.UID
            : undefined;
        const id = t && (typeof t === 'string' ? t : t['@id']);
        const path = typeof id === 'string' && id ? caminhoDe(id, flatten) : '';
        if (!path && !uid) return null;
        return {
          path,
          uid,
          customTitle: it.customTitle,
          customDescription: it.customDescription,
          imageRatio: it.imageRatio,
          imagePosition: it.imagePosition,
        };
      }
      if (it && typeof it['@id'] === 'string' && it['@id']) {
        const path = caminhoDe(it['@id'], flatten);
        const uid = typeof it.UID === 'string' && it.UID ? it.UID : undefined;
        return path || uid ? { path, uid } : null;
      }
      return null;
    })
    .filter(Boolean);
}

const porCaminhos = (caminhos) => ({
  'path.query': caminhos,
  'path.depth': 0,
  b_size: caminhos.length,
  fullobjects: true,
});

// Consultas da busca manual. A `principal` é a mesma no servidor
// (getAsyncData) e no navegador (View), sob a mesma chave: por UID sempre que
// algum item tem UID. O SSR fala com o Zope direto, sem VHM, e uma busca por
// path.query sem o prefixo do site (/Plone) não casa no índice de caminho,
// então por caminho a grade sairia vazia do servidor. Item sem UID (link
// colado à mão no object browser, formato antigo) vai na `complementar`, por
// caminho, que só o navegador faz: ele aparece depois da hidratação, sem
// tirar os outros do HTML do servidor. Sem nenhum UID, a principal é por
// caminho, como antes.
export function consultaManual(itemConfigs) {
  const cfgs = itemConfigs || [];
  const uids = cfgs.filter((c) => c.uid).map((c) => c.uid);
  const caminhos = cfgs.filter((c) => !c.uid && c.path).map((c) => c.path);
  if (uids.length > 0) {
    return {
      principal: { UID: uids, b_size: uids.length, fullobjects: true },
      complementar: caminhos.length > 0 ? porCaminhos(caminhos) : null,
    };
  }
  if (caminhos.length > 0) {
    return { principal: porCaminhos(caminhos), complementar: null };
  }
  return null;
}

export function comporManual(itemConfigs, buscados, flatten) {
  const validos = (buscados || []).filter(
    (it) => it && typeof it['@id'] === 'string',
  );
  const porUid = new Map(
    validos
      .filter((it) => typeof it.UID === 'string')
      .map((it) => [it.UID, it]),
  );
  const porCaminho = new Map(
    validos.map((it) => [caminhoDe(it['@id'], flatten), it]),
  );
  return itemConfigs
    .map((cfg) => {
      const base =
        (cfg.uid && porUid.get(cfg.uid)) ||
        (cfg.path ? porCaminho.get(cfg.path) : undefined);
      if (!base) return null;
      return {
        ...base,
        title: cfg.customTitle || base.title,
        description: cfg.customDescription || base.description,
        __agImageRatio: cfg.imageRatio || undefined,
        __agImagePosition: cfg.imagePosition || undefined,
      };
    })
    .filter(Boolean);
}
